<script setup lang="ts">
import ServiceSettingAddStep4 from "@/views/playground/planner/order-management/service-setting/add/ServiceSettingAddStep4.vue";
</script>

<template>
  <service-setting-add-step4></service-setting-add-step4>
</template>

<style scoped></style>
